import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';
import { useNavigate } from 'react-router-dom';

import config from '../../config';

export default function useDeleteWhiteLabelOrganizationMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id: number) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/whitelabel-organizations/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      navigate('/app/op/whitelabel-organizations');
    },
  });
}
